import { render } from "./simplepiechart.vue?vue&type=template&id=5b2c6703&scoped=true"
import script from "./simplepiechart.vue?vue&type=script&lang=js"
export * from "./simplepiechart.vue?vue&type=script&lang=js"

import "./simplepiechart.vue?vue&type=style&index=0&id=5b2c6703&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2c6703"]])

export default __exports__